'use client';

import { CircleHelp } from 'lucide-react';
import type { LinkProps } from 'shared/ui/link';
import { Link } from 'shared/ui/link';
import type { RequireOne } from 'shared/types';
export const DocsIconHelper = ({
  variant,
  href,
  iconClassName = 'size-5',
  ...props
}: RequireOne<Omit<LinkProps, 'children'>, 'href'> & {
  iconClassName?: string;
}) => {
  return <Link href={href} onClick={e => e.stopPropagation()} variant="no-highlight" {...props} data-sentry-element="Link" data-sentry-component="DocsIconHelper" data-sentry-source-file="docs-icon-helper.tsx">
      <CircleHelp className={iconClassName} data-sentry-element="CircleHelp" data-sentry-source-file="docs-icon-helper.tsx" />
    </Link>;
};